import { formatNumber } from './number';
/**
 * 숫자를 통화 형식으로 포맷팅
 */
export function formatCurrency(amount, currency = 'KRW', locale = 'ko-KR') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    }).format(amount);
}
/**
 * 가격을 버림하여 소수점 자리수로 포맷팅
 * @param price - 포맷팅할 가격
 * @param decimalPlaces - 소수점 자리수 (기본값: 2)
 * @returns 포맷팅된 가격 문자열 (trailing zero 포함)
 * @example
 * formatPriceFloor(1.234567, 4) // "1.2345"
 * formatPriceFloor(1.234567, 2) // "1.23"
 * formatPriceFloor(1.2340, 4) // "1.2340" (trailing zero 보존)
 */
export function formatPriceFloor(price, decimalPlaces = 2) {
    return formatNumber(price, 'ko-KR', {
        roundingMode: 'floor',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    });
}
/**
 * 가격을 반올림하여 소수점 자리수로 포맷팅
 * @param price - 포맷팅할 가격
 * @param decimalPlaces - 소수점 자리수 (기본값: 2)
 * @returns 포맷팅된 가격 문자열 (trailing zero 포함)
 */
export function formatPriceRound(price, decimalPlaces = 2) {
    return formatNumber(price, 'ko-KR', {
        roundingMode: 'round',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
    });
}
/**
 * 백분율을 반올림하여 소수점 2자리로 포맷팅
 * @param percentage
 * @returns
 */
export function formatPercentage(percentage) {
    return formatNumber(percentage, 'ko-KR', {
        roundingMode: 'round',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
/**
 * 파일 크기를 읽기 쉬운 형식으로 포맷팅
 */
export function formatFileSize(bytes) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}
/**
 * 전화번호를 포맷팅
 */
export function formatPhoneNumber(phone) {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
        return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    else if (cleaned.length === 11) {
        return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    return phone;
}
/**
 * 영문 입력을 대문자로 변환하는 함수
 * @param text - 변환할 텍스트
 * @returns 대문자로 변환된 텍스트
 */
export function convertUpperCase(text) {
    if (typeof text !== 'string') {
        console.warn('toUpperCase: 입력값이 문자열이 아닙니다.');
        return '';
    }
    return text.toUpperCase();
}
//# sourceMappingURL=format.js.map